"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stringUtils_1 = require("../stringUtils");
/**
 * Метод фильтрации списка по строке поиска
 * @param objects - список объектов
 * @param nameExtractor - функция доступа к имени, из объектов для фильтрации
 * @param searchText - строка поиска
 */
function filterByString(objects, nameExtractor, searchText) {
    return objects.filter(function (o) {
        return stringUtils_1.isIncludeSubstring(nameExtractor(o), searchText);
    });
}
exports.filterByString = filterByString;
//# sourceMappingURL=filterByString.js.map